import { render, staticRenderFns } from "./AccommodationLetters.vue?vue&type=template&id=7664bbae&scoped=true&"
import script from "./AccommodationLetters.vue?vue&type=script&lang=js&"
export * from "./AccommodationLetters.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationLetters.vue?vue&type=style&index=0&id=7664bbae&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7664bbae",
  null
  
)

export default component.exports